import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from '@mui/material';
import HowItWorksModal from './howItWorksModal';
import { stageShape } from './howItWorksFlow';

const seenStorageKey = (featureKey) => 'howItWorksSeen:'.concat(featureKey);

export default function HowItWorksLink({
  featureKey,
  title,
  subtitle = '',
  stages,
  label = 'Ver como o fluxo funciona',
  autoOpenOnce = false,
}) {
  const [isModalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (!autoOpenOnce) return;
    if (localStorage.getItem(seenStorageKey(featureKey))) return;
    setModalOpen(true);
  }, [autoOpenOnce, featureKey]);

  const closeModal = () => {
    localStorage.setItem(seenStorageKey(featureKey), 'true');
    setModalOpen(false);
  };

  return (
    <>
      <Link
        component="button"
        type="button"
        variant="body2"
        underline="hover"
        onClick={() => setModalOpen(true)}
        sx={{ color: 'text.secondary' }}
      >
        {label}
      </Link>
      <HowItWorksModal
        open={isModalOpen}
        onClose={closeModal}
        title={title}
        subtitle={subtitle}
        stages={stages}
      />
    </>
  );
}

HowItWorksLink.propTypes = {
  featureKey: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  stages: PropTypes.arrayOf(stageShape).isRequired,
  label: PropTypes.string,
  autoOpenOnce: PropTypes.bool,
};
